import { useEffect, useState } from 'react'

const hasFiles = (event: DragEvent) =>
  Array.from(event.dataTransfer?.types ?? []).includes('Files')

// True while a file drag hovers anywhere over the page. Enter and leave fire for every element
// crossed, so a depth counter tells a real leave from a child hand-off.
export const usePageDrag = (enabled: boolean) => {
  const [isDragging, setIsDragging] = useState(false)

  useEffect(() => {
    if (!enabled) return
    let depth = 0

    const onEnter = (event: DragEvent) => {
      if (!hasFiles(event)) return
      depth += 1
      setIsDragging(true)
    }
    const onLeave = () => {
      depth = Math.max(0, depth - 1)
      if (depth === 0) setIsDragging(false)
    }
    const onEnd = () => {
      depth = 0
      setIsDragging(false)
    }

    document.addEventListener('dragenter', onEnter)
    document.addEventListener('dragleave', onLeave)
    document.addEventListener('drop', onEnd)
    document.addEventListener('dragend', onEnd)
    return () => {
      document.removeEventListener('dragenter', onEnter)
      document.removeEventListener('dragleave', onLeave)
      document.removeEventListener('drop', onEnd)
      document.removeEventListener('dragend', onEnd)
    }
  }, [enabled])

  return enabled && isDragging
}
